export const breadcrumbs = {
  driver: [{ link: "/drivers", label: "Drivers list" }],
  order: [{ link: "/operation-room/orders", label: "Orders" }]
};

export const links = {
  editDriver: id => `/drivers/${id}/edit`,
  addDriver: () => `/drivers/add`,
  driver: id => `/drivers/${id}`,
  drivers: () => `/drivers`,
  users: () => `/user-relationship/users`,
  marketing: () => `/user-relationship/marketing`,
  promotionalCodesManagement: () =>
    `/user-relationship/promotional-codes-management`,
  targets: () => `/hr/targets`,
  saleries: () => `/hr/saleries`,
  financeRestaurants: () => `/finance/restaurants`,
  financeDriver: () => `/finance/drivers`,
  map: () => `/operation-room/map`,
  dashboard: () => `/operation-room/dashboard`,
  orders: () => `/operation-room/orders`,
  liveChat: () => `/operation-room/live-chat`,
  customer: id => `/customers/${id}`,
  editCustomer: id => `/customers/${id}/edit`,
  Menu: (id, restId) => `/customers/${id}/edit/${restId}/menu`,
  List: (id, restId, menuId) =>
    `/customers/${id}/edit/${restId}/menu/${menuId}/list`,
  Item: (id, restId, menuId) =>
    `/customers/${id}/edit/${restId}/menu/${menuId}/item`,
  order: id => `/operation-room/orders/${id}`
};

export const COLORS = [
  { key: "Black", value: "black" },
  { key: "White", value: "white" },
  { key: "Silver", value: "silver" },
  { key: "Beige", value: "beige" },
  { key: "Yellow", value: "yellow" },
  { key: "Navy Blue", value: "navy_blue" },
  { key: "Green", value: "green" },
  { key: "Dark Blue", value: "dark_blue" },
  { key: "Red", value: "red" },
  { key: "Violet", value: "violet" },
  { key: "Gray", value: "gray" },
  { key: "Orange", value: "orange" },
  { key: "Brown", value: "brown" },
  { key: "Golden", value: "golden" },
  { key: "Pink", value: "pink" }
];

export const CUSTOMER_TYPES = [
  { key: "TAM", value: "tam" },
  { key: "Foodna", value: "foodna" }
];

export const HOURS = [
  { key: "00:00", value: "00:00" },
  { key: "01:00", value: "01:00" },
  { key: "02:00", value: "02:00" },
  { key: "03:00", value: "03:00" },
  { key: "04:00", value: "04:00" },
  { key: "05:00", value: "05:00" },
  { key: "06:00", value: "06:00" },
  { key: "07:00", value: "07:00" },
  { key: "08:00", value: "08:00" },
  { key: "09:00", value: "09:00" },
  { key: "10:00", value: "10:00" },
  { key: "11:00", value: "11:00" },
  { key: "12:00", value: "12:00" },
  { key: "13:00", value: "13:00" },
  { key: "14:00", value: "14:00" },
  { key: "15:00", value: "15:00" },
  { key: "16:00", value: "16:00" },
  { key: "17:00", value: "17:00" },
  { key: "18:00", value: "18:00" },
  { key: "19:00", value: "19:00" },
  { key: "20:00", value: "20:00" },
  { key: "21:00", value: "21:00" },
  { key: "22:00", value: "22:00" },
  { key: "23:00", value: "23:00" }
];

export const DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];

export const CAR_TYPES = [
  { key: "Cooled", value: "cooled" },
  { key: "Normal", value: "normal" }
];
export const Role = [
  { key: "Super Admin", value: "Super Admin" },
  { key: "Operation Admin", value: "Operation Admin" },
  { key: "Operation Team", value: "Operation Team" },
  { key: "Finance Admin", value: "Finance Admin" },
  { key: "Finance Team", value: "Finance Team" },
  { key: "Marketing Team", value: "Marketing Team" },
  { key: "Customer", value: "Customer" }
];
export const Initiator = [
  { key: "Foodna App", value: "Foodna App" },
  { key: "Non Foodna App", value: "Non Foodna App" },
  { key: "All", value: "All" }
];

export const validate = {
  $tenNumbers: ["onlyNumbersAndPlus", "onlyTenChars", "required"],
  $text: ["onlyText", "required"],
  email: ["email"],
  $email: ["email", "required"],
  $upToSixNumbersAndLetters: [
    "onlyNumbersAndLetters",
    "atLeastSixChars",
    "required"
  ],
  upToSixNumbersAndLetters: ["onlyNumbersAndLetters", "atLeastSixChars"],
  $money: [
    "isOnlyNumbersAndDot",
    "maxFiveDigit",
    "afterDecimalTwoChars",
    "required"
  ],
  $year: ["onlyNumbers", "year", "required"],
  $numbersAndLetters: ["onlyNumbersAndLetters", "required"],
  $numbersSpacesAndLetters: ["isOnlyNumbersSpacesAndLetters", "required"],
  $image: ["image", "required"],
  $required: ["required"],
  image: ["image"],
  $mobile: ["onlyNumbersAndPlus", "onlyTwelveCharsForMob", "required"],
  $licensePlate: ["licensePlate", "required"]
};

export const WEEKDAYS = [
  { id: 1, value: "Sunday", field: "sunday" },
  { id: 2, value: "Monday", field: "monday" },
  { id: 3, value: "Tuesday", field: "tuesday" },
  { id: 4, value: "Wednesday", field: "wednesday" },
  { id: 5, value: "Thursday", field: "thursday" },
  { id: 6, value: "Friday", field: "friday" },
  { id: 7, value: "Saturday", field: "saturday" }
];

export const WEEKDAYS_MAP = {
  "1": "Sunday",
  "2": "Monday",
  "3": "Tuesday",
  "4": "Wednesday",
  "5": "Thursday",
  "6": "Friday",
  "7": "Saturday"
};

export const mapStyles = [
  {
    featureType: "landscape.man_made",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "on"
      },
      {
        color: "#dfdfdf"
      }
    ]
  },
  {
    featureType: "poi.attraction",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#1b1b1b"
      }
    ]
  },
  {
    featureType: "poi.business",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#1b1b1b"
      }
    ]
  },
  {
    featureType: "poi.government",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#1b1b1b"
      }
    ]
  },
  {
    featureType: "poi.medical",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#1b1b1b"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#d2d2d2"
      }
    ]
  },
  {
    featureType: "poi.place_of_worship",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#1b1b1b"
      }
    ]
  },
  {
    featureType: "poi.school",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#1b1b1b"
      }
    ]
  },
  {
    featureType: "poi.sports_complex",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#1b1b1b"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        weight: 5.5
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#838383"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "geometry.stroke",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#50d1cb"
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/utils/constants.js